module.exports = __webpack_public_path__ + "static/media/CSMU_Logo.130dff30.png";